var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var BoldIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 36,
    glyphHeight: 36
  }), React.createElement("path", {
    d: "M11.156 9.548L9.056 9.156V7.196H13.48C14.1147 7.196 14.9547 7.15867 16 7.084C16.224 7.06533 16.504 7.04667 16.84 7.028C17.176 7.00933 17.568 7 18.016 7C20.0507 7 21.6467 7.18667 22.804 7.56C23.9613 7.93333 24.764 8.46533 25.212 9.156C25.6787 9.84667 25.912 10.7147 25.912 11.76C25.912 13.16 25.4733 14.3173 24.596 15.232C23.7373 16.1467 22.636 16.6973 21.292 16.884C23.1587 16.884 24.624 17.304 25.688 18.144C26.7707 18.984 27.312 20.1693 27.312 21.7C27.312 23.6973 26.6213 25.2747 25.24 26.432C23.8773 27.5893 21.5533 28.168 18.268 28.168C17.7453 28.168 17.2413 28.1493 16.756 28.112C16.2707 28.0933 15.9253 28.084 15.72 28.084C15.048 28.028 14.32 28 13.536 28H9V26.152L11.156 25.844V9.548ZM15.888 16.184C16.224 16.2213 16.98 16.24 18.156 16.24C19.1827 16.24 19.9387 15.8947 20.424 15.204C20.9093 14.4947 21.152 13.5053 21.152 12.236C21.152 11.06 20.8907 10.2013 20.368 9.66C19.8453 9.11867 18.996 8.848 17.82 8.848C17.54 8.848 17.2133 8.86667 16.84 8.904C16.4667 8.92267 16.1493 8.95067 15.888 8.988V16.184ZM15.888 26.012C16.2613 26.1613 16.9987 26.236 18.1 26.236C19.4813 26.236 20.48 25.872 21.096 25.144C21.7307 24.416 22.048 23.3613 22.048 21.98C22.048 20.6733 21.7587 19.74 21.18 19.18C20.6013 18.62 19.6867 18.34 18.436 18.34C17.4093 18.34 16.56 18.3587 15.888 18.396V26.012Z",
    fill: "black"
  }));
};
export var BoldIconGlyph = function (props) {
  return React.createElement(BoldIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};